/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type KeyField_data = {
    readonly label: string | null;
    readonly value: ReadonlyArray<{
        readonly key: string;
        readonly " $fragmentRefs": FragmentRefs<"SemanticString_data">;
    }> | null;
    readonly " $refType": "KeyField_data";
};
export type KeyField_data$data = KeyField_data;
export type KeyField_data$key = {
    readonly " $data"?: KeyField_data$data;
    readonly " $fragmentRefs": FragmentRefs<"KeyField_data">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KeyField_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SemanticString",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SemanticString_data"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KeyField",
  "abstractKey": null
};
(node as any).hash = '673c99af38a939d74ec5a10ea0360fcd';
export default node;
